'use client';

import { useTranslations } from 'next-intl';
import { ComponentProps } from 'react';
import { EventService } from '@/shared/lib/event-service';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentProps<typeof Layout>;

export const TermsAndConditionsButton = (props: Props) => {
    const t = useTranslations();
    return (
        <Layout
            element="button"
            type="button"
            onClick={() => EventService.trigger('terms-and-conditions:view-detail', {})}
            media={{
                ...props.media,
                initial: {
                    fontSize: '0.75rem',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    ...props.media?.initial,
                },
                xl: {
                    fontSize: '0.875rem',
                },
            }}
            {...props}
        >
            {t('FOOTER.BOTTOM.TERMS')}
        </Layout>
    );
};
